export default function Profil() {
  return (
    <div className="p-6 max-w-5xl mx-auto text-lightgray space-y-12">
      {/* Profilüberschrift */}
      <h1 className="text-4xl font-bold text-gold border-b border-silver pb-1">Profil</h1>

      {/* 1. Persönliche Daten & Sprachen */}
      <section>
        <h2 className="text-2xl font-semibold text-gold mb-1">Persönliche Daten & Sprachen</h2>
        <ul className="list-disc list-inside space-y-1">
          <li><strong>Name:</strong> Behlül Kelez</li>
          <li><strong>Geburtsdatum:</strong> 28.07.1995</li>
          <li><strong>Geschlecht:</strong> Männlich</li>
          <li><strong>Familienstand:</strong> Verheiratet, 3 Kinder</li>
          <li><strong>Staatangehörigkeit:</strong> Deutsch</li>
          <li><strong>Wohnort:</strong> 59199 Bönen, Kreis Unna, Region Dortmund, NRW</li>
          <li><strong>Sprachen:</strong> Deutsch (C2), Türkisch (C2), Englisch (C1)</li>
          <li><strong>Führerschein:</strong> Klasse B</li>
        </ul>
      </section>

      {/* 2. Ausbildung */}
      <section>
        <h2 className="text-2xl font-semibold text-gold mb-1">Ausbildung</h2>
        <ul className="list-disc list-inside space-y-1">
          <li><strong>Master of Science</strong> in Informationstechnik, FH Dortmund</li>
          <li><strong>Bachelor of Science</strong> in Biomedizintechnik, FH Dortmund</li>
          <li><strong>Zusatzqualifikationen:</strong> SAP IEE2E, SAC, BW/4HANA, Cisco CCNA, DevNet, Cybersecurity</li>
        </ul>
      </section>

      {/* 3. Berufliche Stationen */}
      <section>
        <h2 className="text-2xl font-semibold text-gold mb-1">Berufserfahrung</h2>
        <ul className="list-disc list-inside space-y-1">
          <li><strong>Werkstudent Service Engineering / Hochfrequenztechnik ‑ Kalibration/
Verifikation, EMV Prüfungen</strong> (3 Jahre): Ametek Cts Europe GmbH - 59192 Bergkamen</li>
          <li><strong>Büromanager; Intensiv-Patienten-Beatmung</strong>: ACG - Medizintechnik - 59199 Bönen </li>
          <li><strong>Onlinehandel</strong>: Bücherverkauf auf Onlineplattformen</li>
        </ul>
      </section>

      {/* 4. Hobbys und Interessen */}
      <section>
        <h2 className="text-2xl font-semibold text-gold mb-1">Hobbys & Interessen</h2>
        <ul className="list-disc list-inside space-y-1">
          <li><strong>Kraftsport</strong></li>
          <li><strong>Lesen und Schreiben</strong></li>
          <li><strong>Reisen</strong></li>
          <li><strong>Kochen</strong></li>
          <li><strong>Naturheilkunde</strong></li>
          <li><strong>Psychologie und Pädagogik</strong></li>
          <li><strong>Ernährungswissenschaft</strong></li>
          <li><strong>CAD & 3D-Druck</strong></li>
        </ul>
      </section>

      {/* 5. Profilbeschreibung */}
<section>
  <h2 className="text-2xl font-semibold text-gold mb-1">Kurzprofil</h2>

  <div className="space-y-4 text-lightgray text-base leading-relaxed">
    <p>
      Ich bin Absolvent des Masterstudiengangs Informationstechnik mit Schwerpunkt Kommunikationstechnik. Mein fachliches Interesse liegt im Bereich Business Intelligence und Data Engineering, insbesondere in der strukturierten Datenmodellierung, der Analyse komplexer Datenstrukturen sowie dem Aufbau belastbarer Reporting- und KPI-Konzepte. Im Rahmen meines Studiums und meiner praktischen Tätigkeiten habe ich Erfahrung im Umgang mit strukturierten Daten, analytischen Methoden und BI-Systemen gesammelt. Dabei verbinde ich technisches Verständnis mit einem klaren Blick für betriebliche Zusammenhänge und datenbasierte Entscheidungsprozesse. Mein Ziel ist es, meine Kenntnisse im Bereich Datenarchitektur, BI und analytischer Datenverarbeitung weiter auszubauen und mich fachlich kontinuierlich weiterzuentwickeln.
    </p>

    <p>
      Mit SAP-Zertifikaten in BW/4HANA, SAC und IEE2E sowie umfangreichen Kenntnissen in Netzwerken (CCNA), DevNet und Cybersecurity bin ich in der Lage, Unternehmen bei der Datenverarbeitung, Cloud-Integration und BI-Strategie zu unterstützen. Zusätzlich bringe ich fundierte Erfahrungen in Signal- & Bildverarbeitung, Antennensimulationen und Machine Learning mit, was mir erlaubt, innovative Lösungen in verschiedenen Technologiebereichen zu entwickeln.
    </p>

    <p>
      Meine berufliche Erfahrung umfasst 3 Jahre als Werkstudent im Bereich der Hochfrequenztechnik, wodurch ich analytisches Denken, Präzision und ein starkes Verständnis für technische Prozesse entwickelt habe.
    </p>

    <p>
      💡 <strong>Fachliche Schwerpunkte & Projekte:</strong><br />
      ✔ SAP BW/4HANA & SAC: Entwicklung & Optimierung von BI-Architekturen & Datenmodellen für datengetriebene Entscheidungen.<br />
      ✔ Data Science and Software Engineering<br />
      ✔ Datenanalyse & KI: Verarbeitung und Klassifizierung von Hyperspektraldaten mit Machine Learning (PCA, SVM), Deep Learning (CNN, GAN, Transformer).<br />
      ✔ Hochfrequenztechnik & Kommunikationstechnik: Untersuchung von 5G-Antennenkonzepten & EMPro-Simulationen für Medizintechnik & Telekommunikation.<br />
      ✔ Signalverarbeitung & Medizintechnik: Analyse von physiologischen Signalen (EEG, EKG, PPG, Atemtechnik) mit MATLAB/Simulink & Entwicklung eines CCD-Spektrometers zur spektralen Analyse von Stoffen.<br />
      ✔ Embedded Systems & Automatisierung: Mikroprozessoren (Arduino, RISC-V), API-Integration, DevOps & Netzwerktechnik.
    </p>

    <p>
      Meine Persönlichkeit zeichnet das weitere Streben nach Wissen und der damit verbundene Ehrgeiz aus. Auf diesem Weg achte ich darauf, dass es auf Aufrichtigkeit und Vertrauen basiert. Neue Orte, neue Lösungsansätze, neue Innovationen und neue Ideen sind der Ansporn meiner Laufbahn.
    </p>

    <p>
      In erster Linie möchte ich meiner Pflicht als Ehemann und Vater gerecht werden und ihnen eine schöne Zukunft sichern. Die Menschen auf der ganzen Welt und besonders hilfsbedürftige Menschen sind eine weitere Zielgruppe in meinem Leben. Denn durch solche Hilfen zeigt man den eigenen Erfolgen gegenüber Dankbarkeit. Meine akademische Laufbahn spiegelt meine Interessen perfekt wider.
    </p>

    <p>
      Denn Gesundheit/Medizin und neue technische Innovationen sind meine Interessengebiete. Vor allem glaube ich daran, dass in jedem Bereich des Lebens Informationstechnik eine Rolle spielt und in der Zukunft immer mehr an Wichtigkeit gewinnen wird. Als Beispiel solcher Bereiche kann man in erster Linie die Medizin und somit die Gesundheit der Menschen nennen. Medizintechnik war aus diesem Grund der erste Halt in meiner akademischen Laufbahn.
    </p>

    <p>
      Jedoch ist es mit vielen Bereichen der Ingenieurswissenschaften verbunden. Elektrotechnik, Signaltheorie und Informatik sind Sammelbegriffe, die ich in Erfahrung bringen konnte. Im Master wollte ich mich nun spezifischer und allgemeiner mit der Informationstechnik befassen. Nun fokussiere ich mich hauptsächlich auf Signalanalyse, Computersysteme, Embedded System, KI-Systeme und Kommunikationstechnik. Diese Bereiche stellen auch meine neuen Projekte dar, die auf elektromagnetische Simulationen in der Medizin als auch in Antennenkonzepten beruhen.
    </p>

    <p>
      Mein Studium beende ich mit der finalen Entscheidung in Richtung der Data Science zu gehen und meine Fähigkeiten in SAP und besonders in BW/4HANA auszubauen und zu festigen. Die Master-Thesis beruht aus diesem Grund auch auf Data-Science und handelt über echte Verkehrsdaten von TomTom.
    </p>

    <p>
      Ich bin offen für spannende Herausforderungen im Bereich der Business Intelligence, Data Engineering, SAP-Consultant, IT-Consulting & KI-Technologien und freue mich auf den Austausch mit Fachkollegen und Unternehmen!
    </p>
  </div>
</section>

    </div>
  );
}
